(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire54e0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire54e0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("caUU6", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8dd28f1eea245eea$export$6503ec6e8aabbaf; }, function (v) { return $8dd28f1eea245eea$export$6503ec6e8aabbaf = v; });
var $8dd28f1eea245eea$export$6503ec6e8aabbaf;
var $8dd28f1eea245eea$export$f7ad0328861e2f03;
"use strict";
var $8dd28f1eea245eea$var$mapping = new Map();
function $8dd28f1eea245eea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8dd28f1eea245eea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8dd28f1eea245eea$var$resolve(id) {
    var resolved = $8dd28f1eea245eea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8dd28f1eea245eea$export$6503ec6e8aabbaf = $8dd28f1eea245eea$var$register;
$8dd28f1eea245eea$export$f7ad0328861e2f03 = $8dd28f1eea245eea$var$resolve;

});

parcelRegister("ayHts", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7afecd6a16e87d65$export$bdfd709ae4826697; }, function (v) { return $7afecd6a16e87d65$export$bdfd709ae4826697 = v; });
var $7afecd6a16e87d65$export$bdfd709ae4826697;
var $7afecd6a16e87d65$export$c9e73fbda7da57b6;
var $7afecd6a16e87d65$export$5a759dc7a1cfb72a;
"use strict";
var $7afecd6a16e87d65$var$bundleURL = {};
function $7afecd6a16e87d65$var$getBundleURLCached(id) {
    var value = $7afecd6a16e87d65$var$bundleURL[id];
    if (!value) {
        value = $7afecd6a16e87d65$var$getBundleURL();
        $7afecd6a16e87d65$var$bundleURL[id] = value;
    }
    return value;
}
function $7afecd6a16e87d65$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7afecd6a16e87d65$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7afecd6a16e87d65$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7afecd6a16e87d65$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7afecd6a16e87d65$export$bdfd709ae4826697 = $7afecd6a16e87d65$var$getBundleURLCached;
$7afecd6a16e87d65$export$c9e73fbda7da57b6 = $7afecd6a16e87d65$var$getBaseURL;
$7afecd6a16e87d65$export$5a759dc7a1cfb72a = $7afecd6a16e87d65$var$getOrigin;

});

var $438265d06071d4aa$exports = {};


(parcelRequire("caUU6")).register((parcelRequire("ayHts")).getBundleURL("bc4bY"), JSON.parse('["bc4bY","index.02f0373a.js","72aFk","kitas_in_flensburg.78949304.geojson","eWeL0","flensburg_stadtteile.38166253.geojson","tutzc","marker-icon-default.3c471951.webp","i7lmD","marker-icon-active.b40abc59.webp","jySMm","index.f4088dd9.css"]'));

})();
//# sourceMappingURL=index.runtime.8838a3c0.js.map
